module.exports = __webpack_public_path__ + "static/img/logo16.f0eebf8a.png";